// extracted by mini-css-extract-plugin
export default {"OrCont":"scanQr_OrCont__7dULD","lineAlt":"scanQr_lineAlt__gpyDC","midText":"scanQr_midText__hblfO"};